import { type FilterChip, FilterChipList } from '@features/allocation';
import { useTranslation } from 'react-i18next';
import type { ProjectFilterKey, ProjectFilterState } from '../hooks/useProjectFilters';
import { useProjectStatusLabel } from '../hooks/useProjectStatusLabel';
import { PROJECT_UNITS } from '../types/ProjectList';

const SEARCH_CHIPS = [
  ['axisCode', 'colunas.codigo'],
  ['name', 'colunas.nome'],
  ['clientSearch', 'colunas.cliente'],
  ['contractSearch', 'colunas.contrato'],
  ['projectManagerSearch', 'colunas.gerenteProjeto'],
  ['operationManagerSearch', 'colunas.gerenteOperacao'],
  ['accountDirectorSearch', 'colunas.diretorConta'],
] as const;

export function ProjectListFilterChips({ filterState }: { filterState: ProjectFilterState }) {
  const { t } = useTranslation(['projetos', 'alocacao', 'common']);
  const statusLabel = useProjectStatusLabel();
  const { filters } = filterState;

  const chips: FilterChip<ProjectFilterKey>[] = [];
  for (const [key, labelKey] of SEARCH_CHIPS) {
    const value = filters[key];
    if (value) {
      chips.push({
        key,
        text: t('alocacao:filtros.chips.contem', { field: t(`projetos:${labelKey}`), value }),
      });
    }
  }
  if (filters.unitId !== undefined) {
    chips.push({
      key: 'unitId',
      text: t('alocacao:filtros.chips.selecionado', {
        field: t('projetos:colunas.unidade'),
        name: PROJECT_UNITS.find((unit) => unit.id === filters.unitId)?.code ?? filters.unitId,
      }),
    });
  }
  if (filters.statusIds?.length) {
    chips.push({
      key: 'statusIds',
      text: t('alocacao:filtros.chips.selecionado', {
        field: t('projetos:colunas.situacao'),
        name: filters.statusIds.map(statusLabel).join(', '),
      }),
    });
  }
  for (const [key, labelKey] of [
    ['internal', 'colunas.interno'],
    ['pool', 'colunas.pool'],
  ] as const) {
    const value = filters[key];
    if (value !== undefined) {
      chips.push({
        key,
        text: t('alocacao:filtros.chips.selecionado', {
          field: t(`projetos:${labelKey}`),
          name: value ? t('common:yes') : t('common:no'),
        }),
      });
    }
  }

  return (
    <FilterChipList
      chips={chips}
      onRemove={filterState.clearFilter}
      onClear={filterState.clearFilters}
    />
  );
}
